import { useContext, useCallback } from 'react';
import ComboBoxContext from '../../ComboBoxCTX.js';
import { filterOptions } from '../../utils/listHelper.js';

const useMaskedOnChange = () => {
  const {
    props: { useMask, onFilter, allOptions, applyAriaDisabled },
    setMenuState,
    setInputValue,
    setFocusOptionIdx,
  } = useContext(ComboBoxContext);

  // default onchange when no mask provided
  const handleOnChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (applyAriaDisabled) return;
      setMenuState(true, 'filter', e);
      if (onFilter) {
        // when filtering is controlled we suggest the basic filtering but let the user decide
        onFilter(filterOptions(e.currentTarget.value, allOptions), e.currentTarget.value);
      }
      setFocusOptionIdx('');
      setInputValue(e.currentTarget.value);
    },
    [applyAriaDisabled, setMenuState, onFilter, setFocusOptionIdx, setInputValue, allOptions],
  );

  // onchange used when mask is provided
  const handleOnChangeMask = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, mask?: string) => {
      setMenuState(true, 'filter', e);
      if (mask && onFilter) onFilter(filterOptions(mask, allOptions), mask);
      else if (!mask && onFilter) onFilter(allOptions, '');
    },
    [setMenuState, onFilter, allOptions],
  );

  const onChangeMask = useMask({ valueSetter: setInputValue, onChange: handleOnChangeMask });

  return onChangeMask?.onChange || handleOnChange;
};

export { useMaskedOnChange };
